module.exports = __webpack_public_path__ + "static/media/54_tn.d6a8272f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/54_tn.jpg
// module id = 542
// module chunks = 0